// @flow

import accountChild from 'app/get-help/content/nodes/loggedOut/account';
import createBugOrFeatureRequestChildren from 'app/get-help/content/nodes/common/bugOrFeatureRequest';
import help from 'app/get-help/components/blocks/Help';
import topic from 'app/get-help/components/blocks/Topic';
import { getDefaultFields } from 'app/get-help/content/nodes/common';
import { ZENDESK_CUSTOM_FIELD_IDS } from 'app/get-help/constants';


const isLoggedIn = false;

export const content = {
  label: 'What would you like more help with?',
  zendeskCustomFieldId: ZENDESK_CUSTOM_FIELD_IDS.MORE_INFORMATION_REQUEST,
  items: [
    {
      value: 'bugOrFeatureRequest',
      icon: 'alertTriangle',
      label: 'Report a bug or request a feature',
      zendeskCustomFieldValue: 'cf-bug-report-feature-request',
      child: createBugOrFeatureRequestChildren(isLoggedIn),
    },
    {
      value: 'account',
      icon: 'personCircle',
      label: 'Accounts, pricing, and billing',
      zendeskCustomFieldValue: 'cf-accounts-billing',
      child: accountChild,
    },
    {
      value: 'securityAndPrivacy',
      icon: 'miscSecurity',
      label: 'Security and privacy question',
      zendeskCustomFieldValue: 'cf-security-privacy',
      child: help({ contact: getDefaultFields(isLoggedIn) }),
    },
  ],
};

const Topic = topic(content);

export default Topic;
